//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import Button from 'src/onboarding/components/ui/button/Button';
import metabolismType from '../../assets/images/promise.png';
import styles from './style.module.scss';
import { Caption } from 'src/onboarding/components/typography/Caption/Caption';
import metabolismType2 from '../../assets/images/image-body.png';
import ethnicityNutrition from '../../assets/images/ethnicity-nutrition-promise.png';
import getLocale from 'src/localization/get-locale';

const imageMap = {
  'metabolism-type': metabolismType,
  'metabolism-type-2': metabolismType2,
  'ethnicity-nutrition-promise': ethnicityNutrition,
};

function AnimatedCounter({ value, duration = 2000 }) {
  const [displayValue, setDisplayValue] = useState('0');

  useEffect(() => {
    const numericMatch = value.match(/(\d+\.?\d*)/);
    const suffixMatch = value.match(/([^\d\.]+)/);

    const numericValue = numericMatch ? parseFloat(numericMatch[1]) : 0;
    const suffix = suffixMatch ? suffixMatch[1] : '';

    let start = 0;
    const steps = duration / 16;
    const increment = numericValue / steps;

    const timer = setInterval(() => {
      start += increment;
      if (start >= numericValue) {
        const finalValue =
          numericValue % 1 === 0 ? numericValue.toString() : numericValue.toFixed(1);
        setDisplayValue(`${finalValue}${suffix}`);
        clearInterval(timer);
      } else {
        const currentValue = numericValue % 1 === 0 ? Math.floor(start) : start.toFixed(1);
        setDisplayValue(`${currentValue}${suffix}`);
      }
    }, 16);

    return () => clearInterval(timer);
  }, [value, duration]);

  return (
    <Text size='l' semibold>
      {displayValue}
    </Text>
  );
}

function DynamicPromisePage({ pageConfig, onNext, onPrev }) {
  const showPhotoProcessing = useStore((state) => state.showPhotoProcessing);
  const locale = getLocale();

  const { currentIndex } = useNav();
  const isFirst = currentIndex === 0;
  const [hasAnimated, setHasAnimated] = useState(false);

  const imageSrc = imageMap[pageConfig.id];

  const handleContinue = () => {
    Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
      page: pageConfig.id,
    });
    onNext();
  };

  useEffect(() => {
    setHasAnimated(true);
  }, []);

  return (
    <div
      className={`page ${styles.top}`}
      style={showPhotoProcessing ? { marginTop: '10px' } : { marginTop: '52px' }}
    >
      {!isFirst && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}

      <div className={'wrapper-info'}>
        <Title tag='h2'>{pageConfig.title[locale]}</Title>
        {pageConfig.text && (
          <Text semibold className={'description'}>
            {pageConfig.text[locale]}
          </Text>
        )}
        {pageConfig.subTitle && (
          <Text size='m' medium className='description'>
            {pageConfig.subTitle[locale]}
          </Text>
        )}
      </div>

      <div
        className={styles.image}
        style={{
          backgroundImage: `url(${imageSrc})`,
        }}
      />
      {pageConfig.stats && pageConfig.stats.length > 0 && (
        <div className={styles.reviewsItems}>
          {pageConfig.stats.map((stat, index) => (
            <div key={index} className={styles.reviewItem}>
              {hasAnimated ? (
                <AnimatedCounter value={stat.value} duration={1500} />
              ) : (
                <Text size='l' semibold>
                  {stat.value.includes('%') ? '0.0%' : '0K+'}
                </Text>
              )}
              <Caption size='l' className={styles.itemDescription}>
                {stat.label[locale]}
              </Caption>
            </div>
          ))}
        </div>
      )}

      <div className={'next-wrapper'}>
        <Button onClick={handleContinue} title={'Start quiz'} />
      </div>
    </div>
  );
}

export default DynamicPromisePage;
